<div class="modal-header">
	<h5 class="modal-title">Détail du module : {{ module.type }}</h5>
	<button type="button" class="btn-close" (click)="bsModalRef.hide()"></button>
</div>

<div class="modal-body">
	<p><strong>N° Dossier DH :</strong> {{ parcours.idDemandDH }}</p>
	<p>
		<strong>Bénéficiaire :</strong> {{ parcours.beneficiaire?.firstName }}
		{{ parcours.beneficiaire?.lastName }}
	</p>
	<p>
		<strong>Intervenant :</strong> {{ module.intervenant?.firstName }}
		{{ module.intervenant?.lastName }}
	</p>
	<p>
		<strong>Dates du module :</strong>
		{{ module.startDate | date : 'dd/MM/yyyy' }} -
		{{ module.endDate | date : 'dd/MM/yyyy' }}
	</p>
	<p><strong>Durée prévue :</strong> {{ module.plannedDuration }}h</p>
	<p><strong>Nombre de missions :</strong> {{ module.missions?.length }}</p>

	<div *ngIf="module.missions?.length > 0">
		<h6>Missions :</h6>
		<ul class="list-group">
			<li
				class="list-group-item list-group-item-action"
				*ngFor="let m of module.missions"
				role="button"
				(click)="navigateToMission(m.missionRequest.id)"
			>
				<!-- <div><strong>ID :</strong> {{ m.id }}</div> -->

				<div>
					<strong>Date prévue :</strong>
					{{ m.missionRequest?.date | date : 'dd/MM/yyyy' }}
				</div>
				<div>
					<strong>Heure prévue :</strong>
					{{ formatMinutes(m.missionRequest?.readyTime) }} -
					{{ formatMinutes(m.missionRequest?.dueTime) }}
				</div>

				<!-- <div><strong>État :</strong> {{ m.state }}</div> -->

				<div *ngIf="m.missionRequest?.missionPlace">
					<strong>Lieu :</strong>
					{{ m.missionRequest.missionPlace.nameDisplay }},
					{{ m.missionRequest.missionPlace.address?.label }}
				</div>

				<div
					*ngIf="!m.missionRequest?.missionPlace && m.missionRequest?.remote"
				>
					<strong>Lieu :</strong> Distanciel
				</div>

				<div
					*ngIf="!m.missionRequest?.missionPlace && !m.missionRequest?.remote"
				>
					<strong>Lieu :</strong>
					{{ m.missionRequest?.beneficiaire?.address?.label }}
				</div>
			</li>
		</ul>
	</div>
</div>
